// Added By Jaseem  
// Module Name : ServiceOrder RelatedList

import React, {
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle,
    useRef,
  } from "react";
  import { Button, Col, Row, Spinner, Table, Form } from "react-bootstrap";
  import { Link } from "react-router-dom";
  import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader,
  } from "react-bs-datatable"; 
  import moment from "moment";
  // import { useNavigate } from "react-router-dom";
  // import { useLocation } from "react-router-dom";
  import Confirm from "../Confirm";
  // import TaskEdit from "./TaskEdit";
  // import TaskView from "./TaskView";
  // import Permissionhelper from "../common/Permissionhelper";
  import * as constants from "../../constants/CONSTANT";
  import trasportApi from "../../api/trasportApi";
  import { formatDate } from "../../utils/helper";
//   import "./PurchaseOrder.css"
  
  const RelatedListServiceOrder = ({ parent, refreshTaskList,table }) => {
    const [modalShow, setModalShow] = React.useState(false);
    const [task, setTask] = React.useState("");
    const [modalShowTask, setModalShowTask] = React.useState(false);
    const [modalShowTaskView, setModalShowTaskView] = React.useState(false);
    const [isFollowUp, setModalShowFollowUp] = React.useState(false);
  
  
    // Create table headers consisting of 4 columns.
  
    const [body, setBody] = useState([]);
  
    useEffect(() => {
      taskList();
    }, []);
  
    const taskList = () => {
      console.log("parent?.id  ListViweRElated",parent?.id);
      async function init() {
        let serviceItem = await trasportApi.fetchServiceLineItemsByParentId(parent?.id);
        console.log('serviceItem',serviceItem);
  
        if (serviceItem && serviceItem?.length > 0) {
          setBody(serviceItem);
        } else {
          setBody([]);
        }
      }
      init();
    };
    const handleDelete = (row) => {
      setModalShow(true);
      setTask(row);
    };
  
    const labels = {
      beforeSelect: " ",
    };
  

  
    const submitTasks = () => {
      setModalShowTask(false);
      taskList();
    };
  
    const editTask = (row) => {
      setModalShowTask(true);
      setTask(row);
    };
  
    const viewTask = (row) => {
      setModalShowTaskView(true);
      setTask(row);
    };
  
    const Taskheader = [
      {
        title: "Title",
        prop: "title",
        cell: (row) => (
          <Link onClick={() => viewTask({ row })} state={parent}>
            {row.title}
          </Link>
        ),
      },
      { title: "Type", prop: "type" },
      { title: "Assigned", prop: "owner_name" },
  
      { title: "Status", prop: "status" },
      { title: "Priority", prop: "priority" },
  
      {
        title: "Target Date",
        prop: "targetdate",
        cell: (row) => formatDate(row.targetdate),
      },
      {
        title: "Created Date",
        prop: "createddate",
        cell: (row) => formatDate(row.createddate),
      },
      {
        title: "Actions",
        prop: "id",
        cell: (row) => (
          <>
            <Button className="btn-sm mx-2" onClick={() => editTask({ row })}>
              <i className="fa-regular fa-pen-to-square"></i>
            </Button>
            {/* {Permissionhelper.checkPermission(constants.SUPER_ADMIN) && ( */}
              <Button
                className="btn-sm mx-2"
                variant="danger"
                onClick={() => handleDelete(row)}
              >
                <i className="fa-regular fa-trash-can"></i>
              </Button>
            {/* )} */}
          </>
        ),
      },
    ];
  
    const purchaseLineItemsHeader = [
      {
        title: 'S.No',
        prop: 'sr_no',
      },
      // {
      //   title : 'Assign User',
      //   prop : 'owner_name'
      // },
      {
        title: 'Category',
        prop: 'category_name',
      },
      {
        title: 'Start KM',
        prop: 'start_km',
      },
      {
        title: 'End KM',
        prop: 'end_km',
      },
      {
        title: 'Total Running KM',
        prop: 'total_running_avg',
      },
      {
        title: 'Product',
        prop: 'product_name',
      
      },
      // {
      //   'title': 'Quantity Used', 'prop': 'quantity_used', 
      // },
      {
        title: 'Quantity Used %',
        prop: 'quantity_used',
        cell: (row) => `${row.quantity_used ?? ''}${row.quantity_used ? '%' : ''}`
      },

      // {
      //   'title': 'Packing Size', 'prop': 'product_qty', 
  
      // },
      // {
      //   'title': 'Product Quantity', 'prop': 'product_qty',
      // },
      {
        'title': 'Product Price', 'prop': 'product_price',
      },
      {
        'title': 'Service Price', 'prop': 'saloon_service_price',
      },
      // {
      //   title: 'Rate Per',
      //   prop: 'rate_per',
      
         {
            title: 'Total Price',
            prop: 'id',
            cell: (row) => (
              <Form.Group style={{width : '100px'}}>
                <Form.Control
                  disabled
                  value={(Number(row?.saloon_service_price) || 0) + (Number(row.product_price) || 0)}
                />
              </Form.Group>
            )
          },
      // {
      //   title: 'Total Price',
      //   prop: 'id',
        
      // },
      // {
      //   title: 'Comparing Price',
      //   prop: 'id',
       
      // }
    ];

  
    const headers = purchaseLineItemsHeader
  //   isFollowUp ? FollowUpheader :Taskheader
  
    return (
      <>
        {body ? (
          <DatatableWrapper
            body={body}
            headers={headers}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 5,
              },
            }}
          >
            <Row className="mb-4">
              <Col
                xs={12}
                sm={6}
                lg={4}
                className="d-flex flex-col justify-content-start align-items-start"
              ></Col>
              <Col
                xs={12}
                sm={6}
                lg={4}
                className="d-flex flex-col justify-content-start align-items-start"
              ></Col>
              <Col
                xs={12}
                sm={6}
                lg={4}
                className="d-flex flex-col justify-content-end align-items-end"
              ></Col>
            </Row>
            <Table striped className="related-list-table shadow rounded sm " responsive={true}>
              <TableHeader className="card-header" style={{ background: "#1A293B", color: "white" }}/>
              {
                (body && Array.isArray(body)) ?
                  <TableBody />
                  :
                  <tbody className="">
                    <tr>
                      <td colSpan={100} align="center">
                        <div>
                          <Spinner />
                        </div>
                      </td>
                    </tr>
                  </tbody>
              }
            </Table>
            <Pagination classes={{ buttonGroup: "", button: "bg-custom border-white" }} /> 
          </DatatableWrapper>
        ) : (
          ""
        )}
      </>
    );
  };
  
  export default RelatedListServiceOrder;  //Added By Jaseem 
  
